<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	height="100%"
	fill="currentColor"
	version="1.1"
	viewBox="0 0 20 20"
	width="100%"
	fill-rule="evenodd"
	clip-rule="evenodd"
	class={classes('w-6 h-6 ', additionalClass)}
	><use xlink:href="#ytp-id-50" />
	<path
		d="M10.0004 17.5999C12.016 17.5999 13.9491 16.7992 15.3744 15.3739C16.7997 13.9486 17.6004 12.0155 17.6004 9.9999C17.6004 7.98426 16.7997 6.05117 15.3744 4.62589C13.9491 3.20061 12.016 2.3999 10.0004 2.3999C7.98475 2.3999 6.05166 3.20061 4.62638 4.62589C3.2011 6.05117 2.40039 7.98426 2.40039 9.9999C2.40039 12.0155 3.2011 13.9486 4.62638 15.3739C6.05166 16.7992 7.98475 17.5999 10.0004 17.5999ZM10.9504 6.1999C10.9504 5.94795 10.8503 5.70631 10.6721 5.52815C10.494 5.34999 10.2523 5.2499 10.0004 5.2499C9.74844 5.2499 9.5068 5.34999 9.32864 5.52815C9.15048 5.70631 9.05039 5.94795 9.05039 6.1999V9.9999C9.05044 10.2518 9.15057 10.4934 9.32874 10.6716L12.0153 13.3591C12.1036 13.4474 12.2084 13.5174 12.3237 13.5652C12.439 13.6129 12.5626 13.6375 12.6875 13.6375C12.8123 13.6375 12.9359 13.6129 13.0512 13.5652C13.1665 13.5174 13.2713 13.4474 13.3596 13.3591C13.4479 13.2708 13.5179 13.1661 13.5656 13.0507C13.6134 12.9354 13.638 12.8118 13.638 12.687C13.638 12.5622 13.6134 12.4385 13.5656 12.3232C13.5179 12.2079 13.4479 12.1031 13.3596 12.0149L10.9504 9.6066V6.1999Z"
	/>
</svg>
